import { axiosAPIInstance as axios } from '../../axios-config';

const actions = {
  async createMetric(_, metric) {
    const response = await axios.post('/blade/metrics', metric);
    return response.data.metric;
  },
  async getMetrics() {
    const response = await axios.get('/blade/metrics');
    return response.data.metrics;
  },
  /**
   * same as getMetrics() but only gets the metrics referenced by user's assigned games/classes
   * (unless user has a role that always gets all metrics (e.g. owner, blade, admin, admin-content))
   */
  async getAssignedMetrics(_, { gamesToInclude = [], classesToInclude = [] }) {
    console.log(gamesToInclude, classesToInclude);
    const response = await axios.get('/blade/assignedmetrics', { params: { gamesToInclude, classesToInclude } });
    return response.data.metrics;
  },
  async getMetric(_, { metricId }) {
    const { data } = await axios.get(`/blade/metrics/${metricId}`);
    return data;
  },
  async getMetricTypes({ dispatch }) {
    return dispatch('getMetric', { metricId: 'types' });
  },
  async updateMetric(_, metric) {
    const response = await axios.patch(`/blade/metrics/${metric._id}`, metric);
    return response.data.metric;
  },
  async deleteMetric(_, { metricId, _id }) {
    const did = metricId || _id;
    const response = await axios.delete(`/blade/metrics/${did}`);
    return response.data.metric;
  }
};

export default {
  actions
};



// WEBPACK FOOTER //
// ./src/store/blade/metrics.js